import type { EventDef } from './types';

/** Random events apply a time-limited modifier through the Modifier/buff stack. */
export const EVENTS: readonly EventDef[] = [
  {
    id: 'goldrush', name: 'Goldrausch', kind: 'good', weight: 3, duration: 45,
    description: 'Eine reiche Ader! Abbau-Ausstoß ×3 für eine Weile.',
    effect: { type: 'autoMult', value: 3 },
  },
  {
    id: 'bullmarket', name: 'Hausse', kind: 'good', weight: 3, duration: 40,
    description: 'Die Preise schießen hoch — Verkaufswert ×2,5.',
    effect: { type: 'valueMult', value: 2.5 },
  },
  {
    id: 'powersurge', name: 'Stromstoß', kind: 'good', weight: 2, duration: 35,
    description: 'Das Netz liefert über — Energie ×2.',
    effect: { type: 'energyMult', value: 2 },
  },
  {
    id: 'frenzy', name: 'Klick-Rausch', kind: 'good', weight: 2, duration: 20,
    description: 'Adrenalin! Klickkraft ×7.',
    effect: { type: 'clickMult', value: 7 },
  },
  {
    id: 'caveins', name: 'Einsturz', kind: 'bad', weight: 2, duration: 30,
    description: 'Ein Einbruch halbiert den Abbau, bis er geräumt ist.',
    effect: { type: 'autoMult', value: 0.5 },
  },
  {
    id: 'crash', name: 'Börsencrash', kind: 'bad', weight: 2, duration: 30,
    description: 'Panikverkäufe — Verkaufswert ×0,5.',
    effect: { type: 'valueMult', value: 0.5 },
    requires: { lifetimeEarnings: 5e4 },
  },
  {
    id: 'blackout', name: 'Stromausfall', kind: 'bad', weight: 1, duration: 25,
    description: 'Eine Störung halbiert die Energieerzeugung.',
    effect: { type: 'energyMult', value: 0.5 },
    requires: { building: 'powerplant' },
  },
] as const;

export const EVENT_BY_ID: Record<string, EventDef> = Object.fromEntries(
  EVENTS.map((e) => [e.id, e]),
);
